import { useState, useEffect } from 'react';
import TradingChartModal from './TradingChartModal';

function LivePricesTicker() {
  const [selectedInstrument, setSelectedInstrument] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [prices, setPrices] = useState({
    XAUUSD: { price: 2635.40, change: 0, changePercent: 0 },
    NAS100: { price: 16245.30, change: 0, changePercent: 0 },
    GBPJPY: { price: 193.56, change: 0, changePercent: 0 },
    SP500: { price: 4567.80, change: 0, changePercent: 0 }
  });

  const instruments = [
    { 
      symbol: 'XAUUSD', 
      name: 'Gold', 
      icon: '💰',
      decimals: 2 
    },
    { 
      symbol: 'NAS100', 
      name: 'NASDAQ 100', 
      icon: '📈',
      decimals: 2 
    },
    { 
      symbol: 'GBPJPY', 
      name: 'GBP/JPY', 
      icon: '💷',
      decimals: 2 
    },
    { 
      symbol: 'SP500', 
      name: 'S&P 500', 
      icon: '📊',
      decimals: 2 
    }
  ];

  // Simulate live price updates (for demo purposes)
  // In production, replace with real API like Twelve Data, Finnhub, or Alpha Vantage
  useEffect(() => {
    const updatePrices = () => {
      setPrices(prev => {
        const newPrices = { ...prev };
        
        Object.keys(newPrices).forEach(symbol => {
          // Simulate realistic price movements
          const volatility = {
            XAUUSD: 0.5,  // Gold moves ~$0.50
            NAS100: 5,     // NAS100 moves ~5 points
            GBPJPY: 0.05,  // GBPJPY moves ~0.05 pips
            SP500: 2       // S&P moves ~2 points
          };

          const change = (Math.random() - 0.5) * 2 * volatility[symbol];
          const newPrice = newPrices[symbol].price + change;
          const changePercent = (change / newPrices[symbol].price) * 100;

          newPrices[symbol] = {
            price: parseFloat(newPrice.toFixed(2)),
            change: parseFloat(change.toFixed(2)),
            changePercent: parseFloat(changePercent.toFixed(2))
          };
        });

        return newPrices;
      });
    };

    // Update prices every 2 seconds
    const interval = setInterval(updatePrices, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-zinc-950 border-y border-zinc-800 py-4 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Live Indicator */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00FF7F] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#00FF7F]"></span>
            </span>
            <span className="text-sm font-light text-gray-400 hidden sm:inline">Live Prices</span>
          </div>

          {/* Prices Ticker */}
          <div className="flex-1 overflow-hidden mx-4">
            <div className="flex items-center gap-8 animate-price-marquee">
              {instruments.concat(instruments).map((instrument, index) => {
                const data = prices[instrument.symbol];
                const isPositive = data.change >= 0;

                return (
                  <button
                    key={`${instrument.symbol}-${index}`}
                    onClick={() => {
                      setSelectedInstrument(instrument);
                      setIsModalOpen(true);
                    }}
                    className="flex items-center gap-3 flex-shrink-0 hover:bg-zinc-800/50 px-3 py-2 rounded-lg transition-all cursor-pointer group"
                  >
                    <span className="text-xl group-hover:scale-110 transition-transform">{instrument.icon}</span>
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-white">
                        {instrument.name}
                      </span>
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-bold text-white">
                          {data.price.toFixed(instrument.decimals)}
                        </span>
                        <span className={`text-xs font-medium ${
                          isPositive ? 'text-green-400' : 'text-red-400'
                        }`}>
                          {isPositive ? '▲' : '▼'} {Math.abs(data.changePercent).toFixed(2)}%
                        </span>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Trade Now CTA */}
          <a
            href="https://app.winnersgroundfx.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 px-4 py-2 bg-[#00FF7F] hover:bg-[#00DD6F] text-black font-bold text-sm rounded-lg transition-colors hidden md:block"
          >
            Trade Now →
          </a>
        </div>
      </div>

      {/* Trading Chart Modal */}
      <TradingChartModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        instrument={selectedInstrument}
      />
    </div>
  );
}

export default LivePricesTicker;
